<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>{{ modalTitle }}</h3>
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label>Name <span class="text-danger">*</span></label>
            <input v-model="form.name" type="text" class="form-control" required>
          </div>

          <div class="form-group">
            <label>Phone</label>
            <input v-model="form.phone" type="text" class="form-control">
          </div>

          <div class="form-group">
            <label>Address</label>
            <input v-model="form.address" type="text" class="form-control">
          </div>

          <div class="form-group">
            <label>Project</label>
            <select v-model="form.target_project_id" class="form-control">
              <option value="">Select Project</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">
                {{ project.title }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Category</label>
            <select v-model="form.leads_category_id" class="form-control">
              <option value="">Select Category</option>
              <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                {{ cat.title }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Details</label>
            <textarea v-model="form.details" class="form-control" rows="3"></textarea>
          </div>

          <div class="text-end mt-3">
            <button class="btn btn-primary" type="submit" :disabled="isSubmitting">
              {{ isSubmitting ? 'Saving...' : 'Save' }}
            </button>
            <button class="btn btn-secondary" type="button" @click="$emit('input', false)" :disabled="isSubmitting">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    lead: {
      type: Object,
      default: null
    },
    projects: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        address: '',
        target_project_id: '',
        leads_category_id: '',
        details: ''
      },
      isSubmitting: false
    }
  },
  watch: {
    lead: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = {
            name: newVal.name || '',
            phone: newVal.phone || '',
            address: newVal.address || '',
            target_project_id: newVal.target_project_id || '',
            leads_category_id: newVal.leads_category_id || '',
            details: newVal.details || ''
          }
        } else {
          this.resetForm()
        }
      }
    }
  },
  computed: {
    modalTitle() {
      return this.lead ? 'Edit Lead' : 'Add Lead'
    }
  },
  methods: {
    resetForm() {
      this.form = {
        name: '',
        phone: '',
        address: '',
        target_project_id: '',
        leads_category_id: '',
        details: ''
      }
    },
    submitForm() {
      this.isSubmitting = true
      const url = this.lead ? `/leads/${this.lead.id}` : '/leads'
      const payload = this.lead ? { ...this.form, _method: 'PUT' } : this.form

      axios.post(url, payload)
        .then(() => {
          this.$emit('input', false)
          this.$emit('saved')
          this.resetForm()
        })
        .catch(err => {
          console.error(err)
          alert('Error saving lead')
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
}
</style>


